export const availablePageSizes = [20, 40, 80, 160];
